import 'focus-visible'
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import fallbackLogo from '../../../images/logo-social-media.jpg'

import StructureLayout from '../../_layout/Structure/StructureLayout'
import StructureList from '../../molecules/StructureList/StructureList'
import Spacer from '../../_layout/Spacer'

import handleTrackingScript from '../../../utils/handleTrackingScript'
import handleTrackingCookie from '../../../utils/handleTrackingCookie'
import {
  footerPropTypes,
  headerPropTypes,
  metaPropTypes,
  pageHeaderPropTypes,
  privacyPropTypes,
  settingsPropTypes,
  clientListPropTypes,
} from '../../../utils/commonPropTypes'
import { ColorScheme } from '../../../utils/defaultTypes'
import { loadCssHasPseudoLib } from '../../../utils/loadCssHasPseudoLib'

loadCssHasPseudoLib()

const TopicList = (props) => {
  const { pageContext, location } = props
  const isGatsby = typeof pageContext !== 'undefined'

  const meta = isGatsby ? pageContext.meta : props.meta
  const siteUrl = isGatsby ? pageContext.siteUrl : props.siteUrl
  const trackingUrl = isGatsby ? pageContext.trackingUrl : props.trackingUrl
  const googleSiteVerification = isGatsby ? pageContext.googleSiteVerification : props.googleSiteVerification

  const pageType = isGatsby ? pageContext.pageType : props.pageType
  const surveyEnabled = isGatsby ? pageContext.surveyEnabled : props.surveyEnabled
  const pageHeader = isGatsby ? pageContext.pageHeader : props.pageHeader
  const apis = isGatsby ? pageContext.apis : props.apis
  const header = isGatsby ? pageContext.header : props.header
  const footer = isGatsby ? pageContext.footer : props.footer
  const clientList = isGatsby ? pageContext.clientList : props.clientList
  const privacy = isGatsby ? pageContext.privacy : props.privacy
  const y007 = isGatsby ? pageContext.Y007 : props.Y007
  const y008 = isGatsby ? pageContext.Y008 : props.Y008

  const content = isGatsby ? pageContext.content : props.content
  const settings = isGatsby ? pageContext.settings : props.settings

  useEffect(() => {
    if (trackingUrl) {
      handleTrackingScript(trackingUrl)
    }

    handleTrackingCookie()
  }, [trackingUrl])

  const metaData = Object.assign({}, meta, {
    location,
    siteUrl,
    googleSiteVerification,
    image: !!meta?.image ? meta.image : { url: `${siteUrl}${fallbackLogo}`, alt: 'AOK Logo' },
  })

  return (
    <StructureLayout
      pageType={pageType}
      surveyEnabled={surveyEnabled}
      pageHeader={pageHeader}
      meta={metaData}
      apis={apis}
      header={header}
      footer={footer}
      clientList={clientList}
      privacy={privacy}
      y007={y007}
      y008={y008}
      pageHeaderTheme={ColorScheme.LIGHT}
    >
      <Spacer className="h-48 1280:h-80" />
      <StructureList
        headline={`${settings.count} weitere${settings.count === 1 ? 'r' : ''} Artikel`}
        initialElements={content}
        settings={settings}
      />
    </StructureLayout>
  )
}

TopicList.propTypes = {
  meta: PropTypes.shape(metaPropTypes),
  siteUrl: PropTypes.string,
  trackingUrl: PropTypes.string,
  googleSiteVerification: PropTypes.string,
  pageType: PropTypes.string,
  surveyEnabled: PropTypes.bool,
  pageHeader: PropTypes.shape(pageHeaderPropTypes),
  apis: PropTypes.object,
  header: PropTypes.shape(headerPropTypes),
  footer: PropTypes.shape(footerPropTypes),
  privacy: PropTypes.shape(privacyPropTypes),
  Y007: PropTypes.object,
  Y008: PropTypes.object,
  content: PropTypes.arrayOf(PropTypes.object),
  settings: PropTypes.shape(settingsPropTypes),
  clientList: clientListPropTypes,
}

TopicList.defaultProps = {
  content: [],
}

export default TopicList
